/**
 * Keep the counter in the shared slider controls on the slide in view. Returns
 * a Swiper `slideChange` handler; the markup ships showing the first slide, so
 * an untouched slider needs no update.
 */
export function slideCounter(root) {
  const counter = root.querySelector('.slide-counter');

  return (swiper) => {
    if (counter) {
      counter.textContent = swiper.realIndex + 1;
    }
  };
}
